"use client";

import "@/styles/base/index.scss";
import "react-loading-skeleton/dist/skeleton.css";
import "react-photo-view/dist/react-photo-view.css";

import { Viewport } from "next";
import { Figtree } from "next/font/google";
import { FC, PropsWithChildren } from "react";

import { useInitializeHotjar } from "@/hooks";
import { AppProviders } from "@/providers";
import { ConnectionOff } from "@/shared/components";

const appFont = Figtree({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  style: ["normal", "italic"],
  display: "swap",
});

export const viewport: Viewport = {
  width: "device-width",
  initialScale: 1,
  maximumScale: 1,
  userScalable: false,
};

const RootLayout: FC<PropsWithChildren> = ({ children }) => {
  useInitializeHotjar();
  return (
    <html lang="en">
      <body className={appFont.className}>
        <ConnectionOff />
        <AppProviders>{children}</AppProviders>
      </body>
    </html>
  );
};

export default RootLayout;
